export const cleanUrlParameters = () => {
  return window.history.replaceState({}, "", window.location.pathname);
};
